import React, { useState, useEffect } from "react";
import TopNav from "../../Navbar/topNav";
import SideNav from "../../Navbar/sideNav";
import dashboardclasses from "../dashboard.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { GrFormView } from "react-icons/gr";
import { MdDelete } from "react-icons/md";
import "../../../App.css";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import ScaleLoader from "react-spinners/ScaleLoader";
import { css } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

import { useParams } from "react-router-dom";
function Warehouse() {
    const { id } = useParams();
    const Navigate = useNavigate();
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    let [loading, setLoading] = useState(true);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();
    const onSubmit = (data) => {
        let amount = Number(localStorage.getItem("amount") || 0);
        if (data.type == 2 && amount == 0) {
            toast.error(
                `unable to debit ,current wallet balance of user is zero`,
                {
                    position: "top-center",
                    autoClose: 1000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                }
            );
            return;
        }
        if (data.type == 2 && amount < Number(data?.amount || 0)) {
            toast.error(
                `unable to debit ,current wallet balance of user is Rs. ${amount} only`,
                {
                    position: "top-center",
                    autoClose: 1000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                }
            );
            return;
        }
        Services.creditdebitwallet(
            "POST",
            JSON.stringify({ ...data, UserID: id }),
            token
        )
            .then((res) => {
                setLoading(false);
                console.log(res);
                if (res.Status === 1) {
                    toast.success(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    Navigate(-1);
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    return (
        <>
            <div className={dashboardclasses["dashboard-wrapper"]}>
                <div className={dashboardclasses["dashboard-leftside"]}>
                    <SideNav isactive="customers" />
                </div>
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <TopNav />

                    <div className={dashboardclasses.CategoryWrapper}>
                        <h3>Add Transaction</h3>

                        <div className={dashboardclasses["transaction_add"]}>
                            <form
                                onSubmit={handleSubmit(onSubmit)}
                                className={dashboardclasses["category-form"]}
                                style={{
                                    gridTemplateColumns: "1fr",
                                    width: "600px",
                                }}>
                                <div
                                    className={
                                        dashboardclasses["item-image-upload"]
                                    }>
                                    <label htmlFor="Bannername">
                                        Transaction Type
                                    </label>
                                    <div className={dashboardclasses["select"]}>
                                        <select
                                            {...register("type", {
                                                required: "Type is required",
                                            })}>
                                            <option value="" disabled>
                                                Please Select
                                            </option>
                                            <option value="1">Credit</option>
                                            <option value="2">Debit</option>
                                        </select>

                                        {errors?.type && (
                                            <p
                                                className={
                                                    dashboardclasses["error"]
                                                }>
                                                {errors?.type?.message}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div
                                    className={
                                        dashboardclasses["item-image-upload"]
                                    }>
                                    <label htmlFor="Bannername">Amount</label>
                                    <div className={dashboardclasses["select"]}>
                                        <input
                                            {...register("amount", {
                                                required: "Amount is required",
                                            })}
                                            type="number"
                                        />

                                        {errors?.amount && (
                                            <p
                                                className={
                                                    dashboardclasses["error"]
                                                }>
                                                {errors?.amount?.message}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div
                                    className={
                                        dashboardclasses["item-image-upload"]
                                    }>
                                    <label htmlFor="Bannername">
                                        Description
                                    </label>
                                    <div className={dashboardclasses["select"]}>
                                        <textarea
                                            {...register("Description", {
                                                required:
                                                    "Description is required",
                                            })}
                                        />

                                        {errors?.Description && (
                                            <p
                                                className={
                                                    dashboardclasses["error"]
                                                }>
                                                {errors?.Description?.message}
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <button>Add Transaction</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Warehouse;
